import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBehaviorPhishingClicks = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.7931 12.3333C12.6075 11.1201 12.9827 9.24873 12.4392 7.7814C11.8052 6.07025 9.53502 6.15114 7.96722 6.00142L7.92268 3.10309C7.91328 2.49115 7.41455 2 6.80255 2C6.18382 2 5.68225 2.50157 5.68225 3.12029V5.66667M2.68095 2.72656L13.128 13.7419M5.68186 9.5468L4.88039 8.384C4.55944 7.91833 3.96139 7.733 3.43335 7.93553C2.83683 8.16433 2.51749 8.81213 2.73511 9.4128C3.14089 10.5328 3.78462 11.7828 4.61285 12.8127C5.68399 14.1447 8.56115 14.3105 10.347 13.5386",
		stroke: "#596180",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBehaviorPhishingClicks;
